var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(91, 91, 240)",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 551.297 551.297",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "336.466,551.297 374.716,551.297 374.716,373.168 336.466,384.078  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.329,120.985h-80.134l-8.902,122.869c0.057,0.698,0.344,11.896-6.561,19.106c-3.538,3.701-8.396,5.651-14.057,5.651 c-3.165,0-13.903-0.44-19.221-6.13c-2.084-2.228-3.079-4.972-2.888-7.946l8.874-133.55H208.97 c71.317,15.635,70.14,104.375,70.122,105.302v162.592l2.228,0.994l45.585-13.006l9.562-2.725l38.25-10.91l9.562-2.727 l114.75-32.742c0-14.734,0-73.583,0-135.653C499.029,125.871,443.681,120.985,441.329,120.985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.568,129.294c-4.982-0.765-9.62-1.1-13.99-1.09c-1.578,0-3.088,0.096-4.581,0.201 c-1.73,0.115-3.423,0.287-5.039,0.545c-9.869,1.549-17.691,5.508-23.18,12c-14.095,16.648-9.667,44.103-9.62,44.38l0.058,143.772 l86.225,36.758l12.039,5.135l26.048,11.102v-0.172V226.172c0-0.153,0-0.622,0.01-1.033c0.009-3.911-0.287-19.068-5.317-36.462 C257.069,164.006,240.401,135.252,201.568,129.294z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.852,418.875c0.096,0-32.771,52.174-0.134,84.811c10.06,10.061,23.438,15.156,39.79,15.156 c30.877,0,63.581-18.312,75.964-30.695c17.557-17.557,70.38-76.174,85.996-93.541l-126.856-56.59L66.852,418.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.809,256.371c3.48-3.614,4.025-10.366,3.931-12.67l8.874-122.716l0.688-9.562l3.04-42.037l4.639,0.201 c0.143,0,13.674,0.536,26.048-1.157c8.405-1.147,8.979-7.746,9.008-9.056c0.115-0.966,2.438-13.349,3.596-29.577 c0.822-11.427-6.904-13.206-8.453-13.455L336.055,0l-7.392,111.422l-0.632,9.562l-8.902,134.19 c1.77,2.314,6.426,3.863,12.556,3.863C334.736,259.048,337.069,258.168,338.809,256.371z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBox);
export default __webpack_public_path__ + "static/media/mail-box.55876ea88099f78b89bff2dfc1bb3f7e.svg";
export { ForwardRef as ReactComponent };